"use client"

import { Modal, Spin } from "antd";
import { Dispatch, SetStateAction } from "react";

interface Modal3UIProps {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  hideCloseIcon?: boolean;
  children: React.ReactNode;
  maskClosable?: boolean;
  title: string | React.ReactNode;
  width?: number
  className?: string
 }

const Modal3UI = ({
  isModalOpen,
  setIsModalOpen,
  hideCloseIcon,
  title,
  width,
  className,
  maskClosable = true,
  children,
}: Modal3UIProps) => {
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    
    <Modal
  closeIcon={!hideCloseIcon}
      title={title}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={[]}
      width={width || 450}
      confirmLoading={true}
      destroyOnClose = {true}
      maskClosable ={maskClosable}
      className={`rounded-lg relative bg-transparent ${className}`}
    >
      {children}
    </Modal>
  );
};

export default Modal3UI;
